import Vue from 'vue';
import { mapGetters } from 'vuex';
import { guid } from '@/mixins/guid';
import PurchaseDomain from './purchase';
import OwnedDomain from './owned';

export default Vue.component('add-domain', {
  template: require('./template.html'),
  name: 'add-domain',
  mixins: [guid],
  props: ['modal', 'current-site', 'toggle-modal'],
  computed: {
    ...mapGetters(['currentUser']),
    isFree() {
      return this.currentSite.tier === 'Free';
    },
  },
  data() {
    return {
      loading: false,
      modalContent: null,
      needsPayment: false,
      collabError: false,
    };
  },
  components: {
    PurchaseDomain,
    OwnedDomain,
  },
  watch: {
    modal(o) {
      if (o) {
        this.modalContent = null;
      }
    },
  },
  methods: {
    setModalContent(type) {
      this.needsPayment = false;
      this.collabError = false;
      if (this._isCollaborator({ site: this.currentSite }) && type === 'Purchase') {
        this.collabError = true;
        return;
      }
      if (type === 'Purchase' && !this.currentUser.paymentMethod) {
        this.needsPayment = true;
        return;
      }
      if (!this.isFree && !this._limits.domains.reached) {
        this.modalContent = type;
      }
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
    recheckDomains() {
      this.$emit('check-domains');
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/admin/websites/edit-site/domains/add-domain/index.js